import { Builder } from '@builder.io/react';
import * as queryString from 'query-string';

/*
Note: cookies will not work on '.mpg-builder-harrys.netlify.app'
*/

export function setupContentLoadedDataLayer (pageData, regionConfig, content, variant) {
  // This catches the case of a Builder.isEditing() session of a never-published Draft page, which does not have pageData until published once. The region/country defaults to 'US' so Builder editors can use the US header/footer as defaults until they Publish it for the 1st time.
  if ( !pageData && ( Builder.isEditing || Builder.isPreviewing ) ) {
    console.log("region not set on this page - using default ('US'). Country and variant info will not be pushed into the dataLayer.")
    return
  }

  var variantPath = content.data.url,
      pageName = pageData.name;

  if(variant) {
    // Custom split test redirecting to other builder page
    var variantName = variant.name,
        variantId = variant.id,
        testRatio = variant.testRatio,
        variantData = content.data;
        pageName = variant.pageName;

    variantPath = variant.path;
  } else {
    if (Object.keys(content.variations).length == 0) {          
      // Page is not being A/B tested
      var variantName = "Default_No_Variants",
          variantId = pageData.id,                               // content.testVariationId will be undefined; fallback to pageData
          variantData = content.data,
          testRatio = content.testRatio
    } else if (content.testVariationName == pageData.name) {    
      // OOTB Builder A/B Test - Default
      // the default variation of a page with other variants will return pageData.name in this field. So we re-write it to be 'default' in that case
      var variantName = "Default",
          variantId = pageData.id,
          variantData = content.data
          testRatio = content.testRatio
    } else {
      // OOTB Builder A/B test - Variant
      var variantName = content.testVariationName,
          variantId = content.testVariationId,
          variantData = content["variations"][variantId]["data"],     // The Builder team has said this is not a bug. I disagree. Anyhoo, this workaround works, but is a little silly.
          testRatio = content["variations"][variantId]["testRatio"]  // you cannot trust the top-level content.testRatio for non-Default variations. It will always be the Default variation's testRatio.
    }
  }

  window.dataLayer?.push({
    event: 'builder_data_ready',
    country: regionConfig.country,              // GTM relies upon regex on url path and this variable emitted here to determine country a given landing page is intended for. This is very consequential for the firing of tags, GDPR banners, and the like.
    BLDR_PAGE_NAME: pageName,              // same as content.name in the contentLoaded callback
    BLDR_PAGE_ID: pageData.id,                  // same as content.id in the contentLoaded callback
    LS_VARIANT: variantPath,                    // for backwards compatibility with Lando's page variant tracking
    BLDR_VARIANT_NAME: variantName,
    BLDR_VARIANT_PATH: variantPath,
    BLDR_VARIANT_ID: variantId,
    BLDR_VARIANT_TEST_RATIO: testRatio
  });
}

export function setupCookiesClientside (regionConfig, location, pageData) {
  const genericIsBrowser = typeof window !== "undefined" // this serves the same purpose as Builder.isBrowser, but unlike that function, this always works clientside
  const urlParams = location ? queryString.parse(location.search) : {};

  if (location) {
    window.dataLayer?.push({
      originalLocation: location.href
    });
  }

  // Define which parameters to write to cookies. This whole flow, less some small modifications, was copied as-is from Badger.
  const cookieParams = [
    // "name", URL params for setting a dropdown banner for visitors from a specific source - e.g. "Welcome to Harry's, The Caravan Club Readers!"
    // "code",
    // "offer",
    // 'eid', // experiment id - {{Session - Experiment ID}} - Custom Dimension 14 from GTM -> GA
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'dc', // discount id, auto-applied at checkout
  ];

  var cookieOptions = {
    Path: '/',           // i.e. every page path
    Domain: genericIsBrowser && location && location.port === '8000' ? "localhost" : regionConfig.domain, // if the isBrowser condition was not included, it would break the serverside build. If Builder.isBrowser was used, it would break the clientside.
    SameSite: "Strict", // restrict reads of these cookies to harrys.com (*and* its subdomains)
    Secure: null        // these don't need a value to be set
  //  HttpOnly: null,  // uncommenting this will make the cookies not show up in InspectElement -> Application -> Cookies (making it harder to debug)
  };

  var cookieOptionsStr = Object.keys(cookieOptions).reduce(function(acc, key) {
    return acc + "; " + key + (cookieOptions[key] ? "=" + cookieOptions[key] : "")
  }, '');

  let dcQueryParam = false;
  cookieParams.forEach((cookieParam) => {
    if (cookieParam === 'dc' && cookieParam in urlParams) {
      dcQueryParam = true;
      document.cookie = 'h_dc' + "=" + (urlParams[cookieParam].trim().toUpperCase() || "") + cookieOptionsStr;
    } else if (cookieParam in urlParams) {
      document.cookie = 'h_p_' + cookieParam + "=" + (urlParams[cookieParam] || "") + cookieOptionsStr;
    }
  });

  // If page level discount code is set and there is no dc query parameter, use page level discount code
  if(pageData?.data?.discountCode && !dcQueryParam) {
    document.cookie = 'h_dc=' + pageData?.data?.discountCode + cookieOptionsStr;
  }

}
